import { render } from "./OtpModel.vue?vue&type=template&id=4fabe850&scoped=true"
import script from "./OtpModel.vue?vue&type=script&lang=js"
export * from "./OtpModel.vue?vue&type=script&lang=js"

import "./OtpModel.vue?vue&type=style&index=0&id=4fabe850&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4fabe850"]])

export default __exports__